<template>
  <BillingCTA
    :message="V4_BILLING_COPY.outOfSeatsCta.message"
    :description="description"
    button-text="Add seats"
    size="large-vertical"
    :billing-interaction="{
      cta: TEAM_CTAS.AT_SEAT_LIMIT,
      event_site: EVENT_SITES.OUT_OF_BOTH_SEATS_CTA,
    }"
  />
</template>
<script setup lang="ts">
import { EVENT_SITES, TEAM_CTAS } from '@crossbeam/itly';

import { pluralize } from 'humanize-plus';
import { computed } from 'vue';

import BillingCTA from '@/components/billing/BillingCTA.vue';

import useSeats from '@/composables/useSeats';
import { V4_BILLING_COPY } from '@/constants/billing';
import { CORE, SALES } from '@/constants/team_v4';
import { useTeamStore } from '@/stores';
import { TeamUser } from '@/types/team';
import { injectStrings } from '@/utils';

const { users = [] } = defineProps<{
  users: TeamUser[];
}>();

const teamStore = useTeamStore();
const { seatsRemainingMap } = useSeats();

const coreUserCount = computed(() =>
  users.reduce((agg, user) => {
    const auth = teamStore.getAuthorizationByUserId(user.id);
    if (auth?.seat_type === CORE) agg += 1;
    return agg;
  }, 0),
);

const salesUserCount = computed(() =>
  users.reduce((agg, user) => {
    const auth = teamStore.getAuthorizationByUserId(user.id);
    if (auth?.seat_type === SALES) agg += 1;
    return agg;
  }, 0),
);

const neededCoreSeats = computed(() =>
  Math.max(salesUserCount.value - seatsRemainingMap.value[CORE], 1),
);
const neededSalesSeats = computed(() =>
  Math.max(coreUserCount.value - seatsRemainingMap.value[SALES], 1),
);
const injections = computed(() => [
  neededCoreSeats.value,
  pluralize(neededCoreSeats.value, 'seat'),
  neededSalesSeats.value,
  pluralize(neededSalesSeats.value, 'seat'),
]);
const description = computed(() =>
  injectStrings(V4_BILLING_COPY.outOfSeatsCta.description, {
    values: injections.value,
  }),
);
</script>
